module.exports = __webpack_public_path__ + "static/media/GMMI_Building_Picture_Web.78214dca.gif";